// Copyright ©️ 2026 eVolve MEP, LLC

import { bendInputKeys } from '@evolvemep/api-ts';

import { WrappedSelect } from 'components/Mantine/TypeSafeSelect/WrappedSelect';
import { useBendCreatorFormContext } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/useBendCreatorFormContext';
import { useBendCreatorValidationContext } from 'modules/Shop/EvolveFabrication/BendCreator/FormComponents/useBendCreatorValidationContext';
import { useBendTypes } from 'modules/Shop/EvolveFabrication/BendCreator/useBendTypes';

export const BendTypeSelect = () => {
  const { bendTypes, loading } = useBendTypes();
  const { resetLastValidation } = useBendCreatorValidationContext();
  const form = useBendCreatorFormContext();
  return (
    <WrappedSelect
      label="Bend Type"
      data={bendTypes?.map(({ name }) => name) ?? []}
      loading={loading}
      required
      placeholder="Select a bend type"
      {...form.getInputProps('bendType')}
      onChange={(bendType) => {
        if (form.values.bendType === bendType) return;
        // On changes to the bend type, reset the dimension inputs and preview
        // and clear any errors since they could have been related to a previous selection
        form.setFieldValue('bendType', bendType);
        form.clearFieldError('bendType');
        bendInputKeys.forEach((key) => {
          form.setFieldValue(key, null);
          form.clearFieldError(key);
        });
        resetLastValidation();
      }}
    />
  );
};
